export default "__VITE_ASSET__07fda98e__"